
import { IQueryConditionHandler } from "./handlers/iquerycondition.handler";
import { TextHandler } from "./handlers/text.handler";
import { DateRangeHandler } from "./handlers/daterage.handler";
import { DropDownHandler } from "./handlers/dropdown.handler";
import { NumberRangeHandler } from "./handlers/numberrage.handler";
import { SmartHelpHandler } from "./handlers/smarthelp.handler";
import { ControlType } from '../entity/controltype';
import { SearchHandler } from './handlers/search.handler';
import { DateHandler } from './handlers/date.handler';
import { CheckboxGroupHandler } from './handlers/checkboxgroup.handler';
import { DateRangeTimeHandler } from './handlers/dateragetime.handler';
import { RadioHandler } from './handlers/radio.handler';
import { MonthRangeHandler } from './handlers/monthrage.handler';
import { YearRangeHandler } from './handlers/yearrage.handler';
import { MonthHandler } from './handlers/month.handler';
import { YearHandler } from './handlers/year.handler';
import { InputGroupHandler } from "./handlers/inputgroup.handler";
import { ComboLookUpHandler } from "./handlers/combolookup.handler";

export class QueryConditionHandlerFactory {

    private static _instance: QueryConditionHandlerFactory = null;
    private queryConditionHandlerMapping: Map<ControlType, IQueryConditionHandler> = new Map<ControlType, IQueryConditionHandler>();
    private constructor(){
        this.queryConditionHandlerMapping.set(ControlType.Text, new TextHandler());
        this.queryConditionHandlerMapping.set(ControlType.DateRange, new DateRangeHandler());
        this.queryConditionHandlerMapping.set(ControlType.DateRangeTime, new DateRangeTimeHandler());
        this.queryConditionHandlerMapping.set(ControlType.MonthRange, new MonthRangeHandler());
        this.queryConditionHandlerMapping.set(ControlType.YearRange, new YearRangeHandler());

        this.queryConditionHandlerMapping.set(ControlType.DropDown, new DropDownHandler());
        this.queryConditionHandlerMapping.set(ControlType.NumberRange, new NumberRangeHandler());
        this.queryConditionHandlerMapping.set(ControlType.Help, new SmartHelpHandler());

        this.queryConditionHandlerMapping.set(ControlType.Search, new SearchHandler());
        this.queryConditionHandlerMapping.set(ControlType.Date, new DateHandler());
        this.queryConditionHandlerMapping.set(ControlType.Month, new MonthHandler());
        this.queryConditionHandlerMapping.set(ControlType.Year, new YearHandler());
        this.queryConditionHandlerMapping.set(ControlType.CheckboxGroup, new CheckboxGroupHandler());
        this.queryConditionHandlerMapping.set(ControlType.Radio, new RadioHandler());
        this.queryConditionHandlerMapping.set(ControlType.InputGroup, new InputGroupHandler());
        this.queryConditionHandlerMapping.set(ControlType.ComboLookUp, new ComboLookUpHandler());
    }
    public static getInstance(){
        if(!QueryConditionHandlerFactory._instance){
            QueryConditionHandlerFactory._instance = new QueryConditionHandlerFactory();
        }
        return QueryConditionHandlerFactory._instance;
    }

    getHandler(controlType: ControlType): IQueryConditionHandler{
        return this.queryConditionHandlerMapping.get(controlType);
    }
}